import Select from 'react-select';
import './BranchDropdown.scss';

const BranchDropdown = ({ options, value, onChange }) => {
    return (
        <div className="branch-dropdown">
            <Select
                options={options}
                value={value}
                onChange={onChange}
                isSearchable={false}
                isClearable={true}
                placeholder="Select Branch"
                getOptionLabel={(opt) => opt.label}
                getOptionValue={(opt) => opt.value}
            />
        </div>
    );
};

export default BranchDropdown;
